import { render } from "./ProductCardComponent.vue?vue&type=template&id=beb7fcb6"
import script from "./ProductCardComponent.vue?vue&type=script&lang=js"
export * from "./ProductCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__